<div class="mt-3 leading-snug text-gray-500">
  <p class="text-sm">
    Informujemy, że administratorem danych osobowych klientów sklepu jest Pure
    Beauty Media spółka z ograniczoną odpowiedzialnością z siedzibą w Warszawie
    (kod pocztowy 02-001), Al. Jerozolimskie 85 lokal 21, NIP 9512507422.
  </p>

  <p class="text-sm">
    <a
      [href]="link"
      class="font-bold underline"
      target="_blank">
      <span>Kliknij i dowiedz się więcej</span>
    </a>
    o ochronie Twoich danych.
  </p>
</div>
